module.exports = __webpack_public_path__ + "static/media/cams-ncp-bsc-blue.a62178b4.png";